import { memo, useCallback, useEffect } from 'react';
import { Plus } from 'lucide-react';

import { KawaiiButton } from '@components/button';

interface ChatCreationProps {
  setChatId: (id: number) => void;
}

export const ChatCreationComponent: React.FC<ChatCreationProps> = ({ setChatId }) => {
  const shortcutCallback = useCallback(
    (e: KeyboardEvent) => {
      if (e.ctrlKey && e.key === 'a') {
        setChatId(null!);
      }
    },
    [setChatId],
  );

  useEffect(() => {
    window.addEventListener('keydown', shortcutCallback);
    return () => {
      window.removeEventListener('keydown', shortcutCallback);
    };
  }, [shortcutCallback]);

  return (
    <>
      <KawaiiButton
        type="submit"
        variant="secondary"
        fullWidth
        onClick={() => setChatId(null!)}
        className="p-1 rounded-md border-0 transition-all disabled:opacity-50 shadow-sm shadow-gray-300/50 dark:shadow-gray-900"
      >
        <div className="flex items-center justify-center w-full">
          <div className=" flex items-center justify-center shrink-0">
            <Plus />
          </div>
        </div>
      </KawaiiButton>
    </>
  );
};

ChatCreationComponent.displayName = 'ChatCreationComponent';

export const ChatCreation = memo(ChatCreationComponent);
